define('routes',{
  // Sample Route Definition
  // 'routePath': { name: 'route name', controller: 'ControllerName' }

  // You can register your controller using the following syntext:
  // radioRequests: {
  //   'controllers ControllerName': '@constructor'
  // }

  //Default route - for COI, the default route is the dashboard.
  // Previously:   '*default': { name: 'dashboard', controller: 'DashboardController' },
  '*default': { name: 'default', controller: 'DashboardController' },

  //Campaign manager routes
  'settings/campaignManager': { name: 'campaign:manager', controller: 'CampaignManagerController' },

  // Disclosure Resolution Setting
  'settings/disclosureResolution': { name: 'settings:resolution', controller: 'DisclosureResolutionSettingController' },


  //Disclosure routes
  //  - reviewer/admin routes
  //  - list of all disclosures
  'disclosure/list(/:disclosureStatus)': { name: 'disclosure:list', controller: 'DisclosureListController' },
  //  - list of disclosures assigned to the current authenticated user
  'disclosureAssignedToMe/list/:disclosureReviewerUserId': {
    name: 'disclosureAssignedToMe:list',
    controller: 'DisclosureAssignedToMeListController',
  },
  //Send Ad Hoc Disclosure Notification
  'disclosure/send': { name: 'disclosure:send', controller: 'DisclosureSendAdHocController' },
  //Make selectiopns for Auto Approval of disclosures
  'disclosure/approvals': { name: 'disclosure:approvals', controller: 'DisclosureAutoApprovalController' },


  //  - disclosure form tab route
  'disclosure/form/:primaryId': { name: 'disclosure:form', controller: 'DisclosureFormTabController' },
  //  - disclosure history tab route
  'disclosure/history/:primaryId': { name: 'disclosure:history', controller: 'DisclosureHistoryTabController' },
  //  - disclosure documents tab route
  'disclosure/documents/:primaryId': { name: 'disclosure:documents', controller: 'DisclosureDocumentsTabController' },

  //Template routes (for admin)
  //  - list of available templates
  'template/list': { name: 'template:list', controller: 'TemplateListController' },
  //  - details of a specific template
  'template/detail/:primaryId': { name: 'template:detail', controller: 'TemplateDetailController' },
  //  - preview of form template
  'template/preview/:templateId(/revision/:revisionId)': {
    name: 'template:preview',
    controller: 'TemplatePreviewController',
  },
  //  - history of form revisions
  'template/history/:templateId/revision/:revisionId(/*state)': {
    name: 'template:history',
    controller: 'TemplateHistoryController',
  },

  //Form answer page route for disclosees
  'form/answer/:primaryId/disclosee': { name: 'form:answer:disclosee', controller: 'FormAnswerController' },

  //Reporting route
  'reporting': { name: 'reporting', controller: 'ReportingController' },
});

